import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
// MSAL imports
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import './style.css';
import Clarity from '@microsoft/clarity';
const projectId = "u0xdawl37u"

Clarity.init(projectId);

export const msalInstance = new PublicClientApplication(msalConfig);

    msalInstance.initialize().then(() => {
    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }


    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
        }
    });
    const container = document.getElementById("root");
    const root = ReactDOM.createRoot(container);

    root.render(
            <App pca={msalInstance} />
    );
});